import { lazy, Suspense } from 'react'
import PageMeta from 'src/_shared/components/PageMeta'
import Hero from 'src/pages/VoltPos/components/Hero'

const CallToActionSection = lazy(() => import('src/_shared/components/CallToActionSection'))
const Compatibility = lazy(() => import('src/_shared/components/Compatibility'))
const CustomerSatisfaction = lazy(() => import('src/pages/VoltPos/components/CustomerSatisfaction'))
const Features = lazy(() => import('src/pages/VoltPos/components/Features'))
const Payments = lazy(() => import('src/pages/VoltPos/components/Payments'))

export const VoltPos = (): JSX.Element => {
	return (
		<>
			<PageMeta
				title="VoltPOS - EV Charging Payment Solutions"
				description="VoltPOS offers secure and versatile pay-at-point payment solutions for EV charging stations, supporting a wide range of payment methods for a seamless user experience."
			/>
			<Hero />
			<Suspense fallback={<></>}>
				<Features />
				<Compatibility page="VoltPos" />
				<Payments />
				<CustomerSatisfaction />
				<CallToActionSection />
			</Suspense>
		</>
	)
}
